/* eslint-disable no-unused-vars */
import { getInfo, login, logout } from "../../api/auth";
import { getToken, removeToken, setToken } from "../../utils/auth";
import router, { resetRouter } from "../../router";

const defaulState = () => ({
  id: null,
  token: getToken(),
  username: "",
  firstName: "",
  lastName: "",
  avatar: "",
  roles: [],
  email: "",
  permissions: [],
});

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, defaulState());
  },
  SET_ID: (state, id) => {
    state.id = id;
  },
  SET_TOKEN: (state, { token, duration }) => {
    state.token = token;
    setToken(token, duration);
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_USER: (state, user) => {
    state.firstName = user.first_name;
    state.lastName = user.last_name;
    state.username = user.username;
    state.email = user.email;
    state.id = user.id;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then((response) => {
          const basic = Buffer.from(userInfo.username_email + ":" + userInfo.password).toString(
            "base64"
          );

          commit("SET_TOKEN", { token: basic, duration: userInfo.keepLoggedIn ? 30 : -1 });
          commit("SET_ROLES", [...response.user.groups]);
          commit("SET_PERMISSIONS", [...response.user.user_permissions]);
          commit("SET_USER", { ...response.user });

          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  // TODO
  getInfo({ commit, state }) {
    let debug = true;
    if (debug) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const roles = ["admin"];
          const permissions = ["view data"];
          commit("SET_ROLES", roles);
          commit("SET_PERMISSIONS", permissions);
          resolve({ roles, permissions });
        }, 0);
      });
    }
    return new Promise((resolve, reject) => {
      getInfo()
        .then((response) => {
          const { data } = response;

          if (!data) {
            reject(new Error("Verification failed, please Login again."));
          }

          const { roles, name, avatar, introduction, permissions, id } = data;
          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject(new Error("getInfo: roles must be a non-null array!"));
          }

          commit("SET_ROLES", roles);
          commit("SET_PERMISSIONS", permissions);
          commit("SET_NAME", name);
          commit("SET_AVATAR", avatar);
          commit("SET_INTRODUCTION", introduction);
          commit("SET_ID", id);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          removeToken();
          commit("RESET_STATE");
          resetRouter();
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      removeToken();
      resolve();
    });
  },

  // Dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise((resolve) => {
      const roles = [role.name];
      const permissions = role.permissions.map((permission) => permission.name);
      commit("SET_ROLES", roles);
      commit("SET_PERMISSIONS", permissions);
      resetRouter();

      // generate accessible routes map based on roles
      dispatch("permission/generateRoutes", { roles, permissions }).then((accessRoutes) => {
        router.addRoutes(accessRoutes);
        resolve();
      });
    });
  },
};

export default {
  namespaced: true,
  state: defaulState,
  mutations,
  actions,
};
